import { Icon, Loader } from '@mairistem/composants';
import { request } from '@mairistem/tools';
import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';

import { getDocumentTemporaryUrl } from '@/routes';

interface CycleEditionImpayesPdfProps {
  identifiantDocument?: number | null;
}

/** Ouvre la liste des impayés historisée en PDF au dernier transfert du cycle (REG-904) */
const CycleEditionImpayesPdf = (props: CycleEditionImpayesPdfProps) => {
  const { identifiantDocument } = props;
  const [downloading, setDownloading] = React.useState(false);

  const handleOpen = React.useCallback(
    async (e: React.MouseEvent) => {
      // Le clic ne doit pas sélectionner la ligne du cycle
      e.stopPropagation();
      setDownloading(true);
      try {
        const { url }: { url: string } = await request.get(
          getDocumentTemporaryUrl(identifiantDocument),
        );
        window.open(url, '_blank');
      } catch {
        toast.error("Erreur lors de l'ouverture de la liste des impayés");
      } finally {
        setDownloading(false);
      }
    },
    [identifiantDocument],
  );

  // Pas encore de transfert : rien à consulter
  if (_.isNil(identifiantDocument)) {
    return null;
  }

  return downloading ? (
    <Loader size="mini" active inline />
  ) : (
    <Icon
      name="file pdf"
      size="large"
      link
      fitted
      title="Ouvrir la liste des impayés transférés"
      data-testid="cycle-edition-impayes-pdf"
      onClick={handleOpen}
    />
  );
};

export default CycleEditionImpayesPdf;
